export default __webpack_public_path__ + "static/media/background-voice-cloning.1592bdcf.png";